var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineMusicPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.27 18.38v-6.16C1.21 9.31 2.3 6.56 4.32 4.49 6.34 2.43 9.06 1.3 11.97 1.3c5.96 0 10.8 4.85 10.8 10.81v6.16c0 2.38-1.94 4.32-4.32 4.32-2.38 0-4.32-1.94-4.32-4.32v-2.81a2.59 2.59 0 0 1 5.18 0v3.03c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-3.03c0-.68-.55-1.09-1.09-1.09-.68 0-1.09.55-1.09 1.09v2.81c0 1.53 1.29 2.82 2.82 2.82 1.53 0 2.82-1.29 2.82-2.82v-6.16c0-5.13-4.17-9.31-9.3-9.31-2.51 0-4.84.97-6.58 2.74-1.74 1.77-2.67 4.14-2.62 6.66v6.17c0 1.53 1.29 2.82 2.82 2.82 1.53 0 2.82-1.29 2.82-2.82v-2.81c0-.68-.55-1.09-1.09-1.09-.68 0-1.09.55-1.09 1.09v2.92c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-2.92c0-1.45 1.14-2.59 2.59-2.59a2.59 2.59 0 0 1 2.59 2.59v2.81a4.33 4.33 0 0 1-4.32 4.33c-2.34 0-4.32-1.98-4.32-4.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 11.28 10.8 8.39l-.42.78c-.23.43-.69.7-1.18.7h-.73c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h.64l.79-1.46c.19-.34.54-.52.93-.55.39 0 .74.23.92.57l1.43 2.86.34-.69c.23-.46.68-.74 1.2-.74h.81c.41 0 .75.34.75.75s-.34.75-.75.75h-.71l-.71 1.41c-.18.37-.53.59-.93.59s-.76-.22-.93-.58z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMusicPlay);
export default __webpack_public_path__ + "static/media/vuesax-outline-music-play.20c5a67bdf8d5c0eb1d844850fb4316d.svg";
export { ForwardRef as ReactComponent };